var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CpslCodeInput } from '@usecapsule/react-components';
import { useEffect, useRef, useState } from 'react';
import { styled } from 'styled-components';
import { ModalStep } from '../../utils/steps.js';
import { useCapsuleStore, useModalStore, useUserInfoStore } from '../../stores/index.js';
import { ClickableText, Heading, Hero, Text, SecondaryText, MainContainer } from '../common.js';
export const VerificationCodeStep = () => {
    const email = useUserInfoStore(state => state.email);
    const setStep = useModalStore(state => state.setStep);
    const setWebAuthURLForCreate = useModalStore(state => state.setWebAuthURLForCreate);
    const capsule = useCapsuleStore(state => state.capsule);
    const inputRef = useRef(null);
    const [code, setCode] = useState('');
    const [codeError, setCodeError] = useState('');
    const [resendStatus, setResendStatus] = useState('Resend.');
    const [resendDisabled, setResendDisabled] = useState(false);
    useEffect(() => {
        // Using a small timeout here to ensure the input is mounted before attempting focus
        setTimeout(() => {
            var _a, _b;
            (_b = (_a = inputRef.current.shadowRoot.querySelectorAll('input')) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.focus();
        }, 10);
    }, []);
    useEffect(() => {
        if (code.length === 6) {
            handleSubmitCode();
        }
    }, [code]);
    const handleResendClick = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!resendDisabled) {
            setResendStatus('Resent!');
            setResendDisabled(true);
            yield capsule.resendVerificationCode();
            setTimeout(() => {
                setResendStatus('Resend.');
                setResendDisabled(false);
            }, 3000);
        }
    });
    const handleCodeInput = (e) => {
        if (codeError) {
            setCodeError('');
        }
        setCode(e.detail.value);
    };
    const handleSubmitCode = () => __awaiter(void 0, void 0, void 0, function* () {
        if (code.length === 6 && /^\d+$/.test(code)) {
            try {
                const url = yield capsule.verifyEmail(code);
                setWebAuthURLForCreate(url);
                setStep(ModalStep.BIOMETRIC_CREATION);
            }
            catch (e) {
                if (e.message.includes('429')) {
                    setCodeError('Too many incorrect attempts. Please try again in 10 minutes.');
                }
                else {
                    setCodeError('Incorrect code.');
                }
            }
        }
        else {
            setCodeError('Incorrect code.');
        }
    });
    return (_jsxs(_Fragment, { children: [_jsx(Hero, { icon: "heroEmail" }), _jsxs(StyledMainContainer, { children: [_jsx(Heading, { children: _jsx("span", { children: "Verify Email" }) }), _jsx(SecondaryText, { children: _jsxs("span", { children: ["Please enter the code we sent to", '\n', _jsx(Text, { children: _jsx("span", { children: email }) })] }) })] }), _jsx(StyledCodeInput, { ref: inputRef, length: 6, type: "number", code: code, onCpslInput: handleCodeInput, errorText: codeError }), _jsx(SecondaryText, { children: _jsxs("span", { children: ["Didn\u2019t receive a code?", ' ', _jsx(Text, { children: _jsx(ClickableText, { style: { cursor: resendDisabled ? 'default' : 'pointer' }, onClick: handleResendClick, children: resendStatus }) })] }) })] }));
};
const StyledCodeInput = styled(CpslCodeInput) `
  align-self: center;
`;
const StyledMainContainer = styled(MainContainer) `
  padding-bottom: 8px;
`;
